import type { ComponentType } from 'react';
import {
  Calendar as RawCalendar,
  DateRange as RawDateRange,
  DateRangePicker as RawDateRangePicker,
  DefinedRange as RawDefinedRange,
} from 'react-date-range';
import type {
  CalendarProps,
  DateRangeProps,
  DateRangePickerProps,
  DefinedRangeProps,
} from 'react-date-range';

/**
 * @types/react-date-range resolves its own nested @types/react@19, whose
 * Component instance type lacks `refs` and so fails this app's React 18
 * JSX.ElementClass check (TS2786). Re-export the components as plain
 * function-component types to decouple them from that mismatched namespace.
 */
export const Calendar = RawCalendar as unknown as ComponentType<CalendarProps>;
export const DateRange = RawDateRange as unknown as ComponentType<DateRangeProps>;
export const DateRangePicker = RawDateRangePicker as unknown as ComponentType<DateRangePickerProps>;
export const DefinedRange = RawDefinedRange as unknown as ComponentType<DefinedRangeProps>;

export type {
  CalendarProps,
  DateRangeProps,
  DateRangePickerProps,
  DefinedRangeProps,
  Range,
  RangeKeyDict,
} from 'react-date-range';
